// Heure d'un rendez-vous = heure du salon. L'API la renvoie notée en UTC
// (10:00 au salon = "…T10:00:00.000Z") : on l'affiche donc toujours en UTC,
// quel que soit le fuseau de l'appareil qui consulte.

export const SALON_TIMEZONE = "Africa/Porto-Novo";

const DEFAULT_OPTIONS = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
};

/** Date et heure d'un rendez-vous (options Intl, comme toLocaleString). */
export const formatSalonDateTime = (value, options = DEFAULT_OPTIONS) => {
  if (!value) return "-";
  const date = new Date(value);
  if (isNaN(date.getTime())) return "-";
  return date.toLocaleString("fr-FR", { ...options, timeZone: "UTC" });
};

/** Date seule d'un rendez-vous. */
export const formatSalonDate = (
  value,
  options = { day: "2-digit", month: "2-digit", year: "numeric" },
) => formatSalonDateTime(value, options);

/** Heure seule d'un rendez-vous ("HH:mm"). */
export const formatSalonTime = (value) =>
  formatSalonDateTime(value, { hour: "2-digit", minute: "2-digit" });

/** "YYYY-MM-DD" du jour d'un rendez-vous. */
export const salonDateKey = (value) => new Date(value).toISOString().slice(0, 10);

/**
 * Date locale aux mêmes chiffres que l'heure du salon, pour les bibliothèques
 * de calendrier qui travaillent en heure locale (react-big-calendar, date-fns).
 */
export const toCalendarDate = (value) => {
  const d = new Date(value);
  return new Date(
    d.getUTCFullYear(),
    d.getUTCMonth(),
    d.getUTCDate(),
    d.getUTCHours(),
    d.getUTCMinutes(),
  );
};

/** Heure actuelle du salon, notée comme les rendez-vous (comparable). */
export const salonNow = () => {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: SALON_TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  }).formatToParts(new Date());
  const get = (type) => Number(parts.find((p) => p.type === type)?.value);
  return new Date(
    Date.UTC(get("year"), get("month") - 1, get("day"), get("hour"), get("minute"), get("second")),
  );
};
